import { z } from 'zod';

import { zodTimeStamp } from '@/utils/zodUtils';

import { BankAccount } from './bank-account';
import { PayoutInsights } from './payout';

export const Customer = z.object({
  id: z.string(),
  name: z.string(),
  address: z.string(),
  email: z.union([
    z.string().email({ message: 'Invalid email address' }),
    z.string().length(0),
  ]),
  phone: z.string(),
  payout_mode: z.enum(['manual', 'instant', 'daily', 'weekly', 'monthly']),
  enforcement_payout_mode: z.enum([
    'manual',
    'instant',
    'daily',
    'weekly',
    'monthly',
  ]),
  timezone: z.string().optional().default(''),
  net_invoice_payout_percent: z.number(),
  created_at: zodTimeStamp,
  updated_at: zodTimeStamp.nullable(),
  bank_accounts: z.array(BankAccount).optional(),
  payout_insights: PayoutInsights.optional(),
});

export const CustomerCreateSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  address: z.string().min(1, 'Address is required'),
  email: z.string().email({}),
  phoneNumber: z.string().min(1, 'Phone number is required'),
  payout_mode: z.enum(['manual', 'instant', 'daily', 'weekly', 'monthly']),
  enforcement_payout_mode: z.enum([
    'manual',
    'instant',
    'daily',
    'weekly',
    'monthly',
  ]),
  timezone: z.string().min(1, 'Timezone is required'),
  netInvoicePayoutPercent: z.coerce
    .number()
    .min(0)
    .max(100, 'Must be between 0 and 100'),
});

export type CustomerType = z.infer<typeof Customer>;
export const CustomerList = z.array(Customer);
export type CustomerListType = z.infer<typeof CustomerList>;
export type CustomerCreateSchemaType = z.infer<typeof CustomerCreateSchema>;
